module.exports = __webpack_public_path__ + "img/89.5273e129.jpg";